export enum PaymentMethod {
  IDEAL = <any>'IDEAL',
  CREDITCARD = <any>'CREDITCARD',
  DIRECTDEBIT = <any>'DIRECTDEBIT'
}